/**
 * @generated SignedSource<<1f8c895da17844a0d223c53050ca0e29>>
 * @relayHash ad44c25bd59eca79ee3ec447a0ac770c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/557.0.0-2026-04-29T16:01:43.567Z/PdpRespMarketplaceLayoutPrimaryRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type PdpRespMarketplaceLayoutPrimaryRefetchQuery$variables = {
  afterDisplay: boolean;
  afterDisplayOrBtSsr: boolean;
  fetchPdp: boolean;
  fetchUser: boolean;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  isEstimateSimilarSoldVariant: boolean;
  isInteractivePdpChat: boolean;
  isMultiSku: boolean;
  isPDPLargerItemsVariant: boolean;
  isPdpSiderailSellerReviewCombinedVariant: boolean;
  isPdpSimilarSoldItemsModuleVariant: boolean;
  isTrade: boolean;
  itemId: string;
  itemIds: ReadonlyArray<string | null>;
  personalizationId?: string | null;
  priceBookName?: string | null;
  similarItemsCount?: number | null;
  userCountryCode?: string | null;
  userId: string;
  userIds?: ReadonlyArray<string | null> | null;
  userZipCode?: string | null;
};
export type PdpRespMarketplaceLayoutPrimaryRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceLayoutPrimary_viewer">;
  };
};
export type PdpRespMarketplaceLayoutPrimaryRefetchQuery = {
  response: PdpRespMarketplaceLayoutPrimaryRefetchQuery$data;
  variables: PdpRespMarketplaceLayoutPrimaryRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDisplay"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "afterDisplayOrBtSsr"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchPdp"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fetchUser"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "followSearchPages"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "followSearchTypes"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isEstimateSimilarSoldVariant"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isInteractivePdpChat"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isMultiSku"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPDPLargerItemsVariant"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPdpSiderailSellerReviewCombinedVariant"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPdpSimilarSoldItemsModuleVariant"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isTrade"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "itemIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personalizationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "priceBookName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "similarItemsCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userCountryCode"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userZipCode"
  }
],
v1 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v2 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = [
  {
    "kind": "Variable",
    "name": "itemIds",
    "variableName": "itemIds"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v12 = {
  "alias": "monthsSinceStartDate",
  "args": [
    {
      "kind": "Literal",
      "name": "unit",
      "value": "MONTH"
    }
  ],
  "kind": "ScalarField",
  "name": "timeSinceStartDate",
  "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerProfile",
  "kind": "LinkedField",
  "name": "sellerProfile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": "isRewardsTier2",
  "args": [
    {
      "kind": "Literal",
      "name": "listName",
      "value": "SELLER_REWARDS_2"
    }
  ],
  "kind": "ScalarField",
  "name": "isAnchorListMember",
  "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGoldTier",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPlatinumTier",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerTierDataNotFound",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerTiers",
  "kind": "LinkedField",
  "name": "sellerTiers",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "SellerOrderFeedbackPdpQueryMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatedOrderFeedbackType",
      "kind": "LinkedField",
      "name": "aggregatedFeedback",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AggregatedOrderFeedbackQuestionType",
          "kind": "LinkedField",
          "name": "overallExperience",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mean",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicNoteTotalResults",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDistinguished",
  "storageKey": null
},
v21 = [
  (v2/*: any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v24 = [
  (v9/*: any*/),
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showAcceptOffer",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showPurchase",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showMakeOffer",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showRequestPrice",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showFollowCategory",
  "storageKey": null
},
v30 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CTADisplay",
    "kind": "LinkedField",
    "name": "ctas",
    "plural": false,
    "selections": [
      (v27/*: any*/)
    ],
    "storageKey": null
  }
],
v31 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "small"
  }
],
v32 = {
  "alias": null,
  "args": (v31/*: any*/),
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"small\")"
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skuId",
  "storageKey": null
},
v34 = {
  "kind": "Literal",
  "name": "catchNonFatalErrors",
  "value": false
},
v35 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v36 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v37 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v38 = [
  (v9/*: any*/),
  {
    "kind": "Literal",
    "name": "canShowOnHoldForDifferentBuyer",
    "value": false
  },
  (v34/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v41 = [
  (v39/*: any*/),
  (v40/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v41/*: any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVatIncluded",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": (v38/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "originalConvertedAmountList",
      "plural": true,
      "selections": (v41/*: any*/),
      "storageKey": null
    },
    (v42/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "privateOfferConvertedAmountList",
      "plural": true,
      "selections": (v41/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageOff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privateOfferPercentageOff",
      "storageKey": null
    },
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerExpirationDate",
      "storageKey": null
    },
    (v44/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceBookName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "condition": "isMultiSku",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v45/*: any*/)
  ]
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pdpURL",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largePath",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryPath",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnlimitedQuantity",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnpurchasable",
  "storageKey": null
},
v64 = {
  "alias": "priceType",
  "args": [
    {
      "kind": "Literal",
      "name": "buyerId",
      "value": ""
    },
    (v34/*: any*/),
    {
      "kind": "Literal",
      "name": "isTrade",
      "value": false
    }
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v43/*: any*/)
  ],
  "storageKey": "displayPrice(buyerId:\"\",catchNonFatalErrors:false,isTrade:false)"
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivateVisibilityType",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": (v10/*: any*/),
  "concreteType": "Transaction",
  "kind": "LinkedField",
  "name": "lastActiveTransaction",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasCompletedCheckout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transactionType",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrivateListing",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "USD",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPricing",
  "kind": "LinkedField",
  "name": "pricing",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "kind": "LinkedField",
          "name": "convertedAmounts",
          "plural": false,
          "selections": [
            (v69/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "GBP",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "EUR",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "CAD",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "AUD",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "CHF",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "MXN",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "NOK",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "SEK",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "DKK",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v72 = [
  (v62/*: any*/)
],
v73 = [
  (v42/*: any*/),
  (v44/*: any*/)
],
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "Hold",
  "kind": "LinkedField",
  "name": "activeHold",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayTimeToExpire",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v75 = [
  (v9/*: any*/),
  {
    "kind": "Literal",
    "name": "isBuyerEstimateEnabled",
    "value": true
  },
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/)
],
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v40/*: any*/),
    (v39/*: any*/)
  ],
  "storageKey": null
},
v77 = [
  (v76/*: any*/)
],
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "price",
  "plural": false,
  "selections": (v77/*: any*/),
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "minAmount",
  "plural": false,
  "selections": (v77/*: any*/),
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "maxAmount",
  "plural": false,
  "selections": (v77/*: any*/),
  "storageKey": null
},
v81 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v75/*: any*/),
      "concreteType": "PricingGuidance",
      "kind": "LinkedField",
      "name": "pricingGuidance",
      "plural": false,
      "selections": [
        (v78/*: any*/),
        (v79/*: any*/),
        (v80/*: any*/)
      ],
      "storageKey": null
    }
  ]
},
v82 = {
  "alias": null,
  "args": [
    (v37/*: any*/),
    (v2/*: any*/),
    {
      "kind": "Variable",
      "name": "userZipCode",
      "variableName": "userZipCode"
    }
  ],
  "kind": "ScalarField",
  "name": "pdpTrackingVpvParams",
  "storageKey": null
},
v83 = {
  "alias": "makeOfferVpvParams",
  "args": [
    {
      "kind": "Literal",
      "name": "excludedPurchaseStatuses",
      "value": [
        "RET",
        "CUST"
      ]
    },
    (v2/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "pdpTrackingVpvParams",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mm",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "us",
  "storageKey": null
},
v86 = [
  {
    "kind": "Literal",
    "name": "shortTitles",
    "value": true
  }
],
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabType",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabTitle",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentHeader",
  "storageKey": null
},
v90 = [
  (v52/*: any*/),
  (v53/*: any*/)
],
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentBodyText",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "browseLink",
  "plural": false,
  "selections": (v90/*: any*/),
  "storageKey": null
},
v93 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v94 = [
  (v11/*: any*/),
  (v5/*: any*/)
],
v95 = [
  {
    "kind": "Literal",
    "name": "fullCountryName",
    "value": true
  }
],
v96 = {
  "kind": "Literal",
  "name": "feedbackSellerPublicNoteHasText",
  "value": true
},
v97 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v98 = {
  "kind": "Literal",
  "name": "minimumReviewRating",
  "value": 4
},
v99 = [
  (v8/*: any*/)
],
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sellerOrderQuantity",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "concreteType": "Profile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    (v101/*: any*/)
  ],
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCustomizable",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": (v94/*: any*/),
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "customizable",
  "plural": true,
  "selections": [
    (v104/*: any*/),
    (v51/*: any*/)
  ],
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "ringResizable",
  "plural": true,
  "selections": [
    (v104/*: any*/)
  ],
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeValue",
  "kind": "LinkedField",
  "name": "leadTime",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeOption",
      "kind": "LinkedField",
      "name": "option",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seoDescription",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailKey",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "delimiter",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "detailDisplayName",
  "storageKey": null
},
v112 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isPdpDetailValueInterface"
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayDetails",
  "storageKey": null
},
v114 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v62/*: any*/)
],
v115 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RingSizeDetail",
      "kind": "LinkedField",
      "name": "ringSizes",
      "plural": true,
      "selections": (v114/*: any*/),
      "storageKey": null
    }
  ],
  "type": "PdpDetailRingSize",
  "abstractKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "PdpDetail",
  "kind": "LinkedField",
  "name": "pdpDetailsDisplay",
  "plural": true,
  "selections": [
    (v109/*: any*/),
    (v110/*: any*/),
    (v111/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "detailValues",
      "plural": true,
      "selections": [
        (v8/*: any*/),
        (v112/*: any*/),
        (v109/*: any*/),
        (v49/*: any*/),
        (v50/*: any*/),
        (v113/*: any*/),
        (v33/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "price",
              "plural": false,
              "selections": [
                (v42/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "PdpDetailVersionsValue",
          "abstractKey": null
        },
        (v115/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAvailable",
  "storageKey": null
},
v118 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "htmlCopy",
    "storageKey": null
  }
],
v119 = {
  "condition": "afterDisplay",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": [
        (v37/*: any*/)
      ],
      "concreteType": "InlineCtaCopy",
      "kind": "LinkedField",
      "name": "returnPolicySection",
      "plural": false,
      "selections": (v118/*: any*/),
      "storageKey": null
    }
  ]
},
v120 = {
  "alias": null,
  "args": null,
  "concreteType": "InlineCtaCopy",
  "kind": "LinkedField",
  "name": "customizableDetailReturnCopy",
  "plural": false,
  "selections": (v118/*: any*/),
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "concreteType": "InlineCtaCopy",
  "kind": "LinkedField",
  "name": "returnPolicySectionHeader",
  "plural": false,
  "selections": (v118/*: any*/),
  "storageKey": null
},
v122 = [
  (v9/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/)
],
v123 = {
  "alias": "recommendedPrice",
  "args": (v122/*: any*/),
  "concreteType": "PricingGuidance",
  "kind": "LinkedField",
  "name": "pricingGuidance",
  "plural": false,
  "selections": [
    (v78/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "medianAmount",
      "plural": false,
      "selections": (v77/*: any*/),
      "storageKey": null
    },
    (v79/*: any*/),
    (v80/*: any*/)
  ],
  "storageKey": null
},
v124 = {
  "alias": "recommendedPrice",
  "args": (v122/*: any*/),
  "concreteType": "PricingGuidance",
  "kind": "LinkedField",
  "name": "pricingGuidance",
  "plural": false,
  "selections": [
    (v61/*: any*/)
  ],
  "storageKey": null
},
v125 = [
  (v40/*: any*/),
  (v76/*: any*/)
],
v126 = {
  "alias": null,
  "args": (v75/*: any*/),
  "concreteType": "PricingGuidance",
  "kind": "LinkedField",
  "name": "pricingGuidance",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": (v125/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "minAmount",
      "plural": false,
      "selections": (v125/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "maxAmount",
      "plural": false,
      "selections": (v125/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": (v21/*: any*/),
  "concreteType": "ReturnPolicy",
  "kind": "LinkedField",
  "name": "returnPolicy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeEuReturns",
          "value": true
        },
        (v37/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "returnDays",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v128 = [
  {
    "kind": "Literal",
    "name": "size",
    "value": "thumb"
  }
],
v129 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "itemThumbnail",
          "args": (v128/*: any*/),
          "kind": "ScalarField",
          "name": "firstPhotoWebPath",
          "storageKey": "firstPhotoWebPath(size:\"thumb\")"
        }
      ]
    }
  ]
},
v130 = {
  "condition": "fetchUser",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": (v10/*: any*/),
      "kind": "ScalarField",
      "name": "hasActiveHoldForBuyer",
      "storageKey": null
    }
  ]
},
v131 = [
  (v48/*: any*/),
  (v5/*: any*/)
],
v132 = {
  "alias": "photoUrl",
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "master"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"master\")"
},
v133 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v134 = {
  "alias": null,
  "args": (v38/*: any*/),
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": (v77/*: any*/),
  "storageKey": null
},
v135 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "measurementUnit",
  "storageKey": null
},
v136 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v137 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemConvertedMeasurementsType",
      "kind": "LinkedField",
      "name": "convertedMeasurementsList",
      "plural": true,
      "selections": [
        (v135/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        },
        (v136/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "depth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diameter",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryHeight",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v138 = {
  "alias": null,
  "args": null,
  "concreteType": "MCAnalytics",
  "kind": "LinkedField",
  "name": "analytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MCAnalyticsMetrics",
      "kind": "LinkedField",
      "name": "metrics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MCMetricResponseTime",
          "kind": "LinkedField",
          "name": "responseTime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summaryCopy",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v139 = {
  "alias": null,
  "args": (v10/*: any*/),
  "kind": "ScalarField",
  "name": "hasRequestedHoldForBuyer",
  "storageKey": null
},
v140 = {
  "alias": null,
  "args": (v24/*: any*/),
  "concreteType": "ItemDisplayInfo",
  "kind": "LinkedField",
  "name": "displayInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showHoldRequest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v141 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v142 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJewelrySeller",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v143 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "leadTimeDisplay",
  "storageKey": null
},
v144 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vimeoId",
  "storageKey": null
},
v145 = {
  "kind": "Literal",
  "name": "includePlayButton",
  "value": false
},
v146 = {
  "kind": "Literal",
  "name": "pad",
  "value": false
},
v147 = {
  "alias": null,
  "args": [
    (v145/*: any*/),
    (v146/*: any*/),
    {
      "kind": "Literal",
      "name": "size",
      "value": "w100h75"
    }
  ],
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w100h75\")"
},
v148 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemReviewDocumentList",
  "kind": "LinkedField",
  "name": "reviews",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemReview",
      "kind": "LinkedField",
      "name": "videoReview",
      "plural": false,
      "selections": [
        (v68/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v149 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v150 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v151 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "IN"
        }
      ],
      "concreteType": "ItemConvertedMeasurementsType",
      "kind": "LinkedField",
      "name": "convertedMeasurements",
      "plural": false,
      "selections": [
        (v136/*: any*/)
      ],
      "storageKey": "convertedMeasurements(unit:\"IN\")"
    },
    {
      "alias": "widthDimensions",
      "args": [
        (v150/*: any*/),
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "width"
          ]
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v114/*: any*/),
      "storageKey": "display(addLabel:false,fields:[\"width\"])"
    },
    {
      "alias": "heightDimensions",
      "args": [
        (v150/*: any*/),
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height"
          ]
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v114/*: any*/),
      "storageKey": "display(addLabel:false,fields:[\"height\"])"
    }
  ],
  "storageKey": null
},
v152 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v153 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "sortedPhotos",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    (v56/*: any*/),
    (v152/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageSkuXref",
      "kind": "LinkedField",
      "name": "imageSkuXrefs",
      "plural": true,
      "selections": [
        (v33/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alt",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v154 = {
  "alias": null,
  "args": null,
  "concreteType": "viewInRoomPhotos",
  "kind": "LinkedField",
  "name": "viewInRoomPhotos",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "src",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotosCenterPosition",
      "kind": "LinkedField",
      "name": "centerPosition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "top",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "left",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotosComparatorWidth",
      "kind": "LinkedField",
      "name": "comparatorWidth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pixel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inches",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v155 = [
  (v40/*: any*/),
  (v39/*: any*/),
  (v42/*: any*/)
],
v156 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  },
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "requestSourceRole",
    "value": "BUYER"
  }
],
v157 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v158 = [
  (v157/*: any*/)
],
v159 = {
  "alias": null,
  "args": (v156/*: any*/),
  "concreteType": "SimilarSoldItemsConnectionConnection",
  "kind": "LinkedField",
  "name": "similarSoldItemsConnection",
  "plural": false,
  "selections": (v158/*: any*/),
  "storageKey": null
},
v160 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v161 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singleItemSoldPrice",
  "storageKey": null
},
v162 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "countryCode",
      "variableName": "userCountryCode"
    }
  ],
  "kind": "ScalarField",
  "name": "isGdprApplicable",
  "storageKey": null
},
v163 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketingOptInMessage",
  "storageKey": null
},
v164 = {
  "alias": "suppressNewSellerSignals",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "suppressNewSellerSignals"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"suppressNewSellerSignals\")"
},
v165 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "similarSoldItemsResults",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 0
        },
        (v1/*: any*/)
      ],
      "concreteType": "SimilarSoldItemsConnection",
      "kind": "LinkedField",
      "name": "similarSoldItems",
      "plural": false,
      "selections": (v158/*: any*/),
      "storageKey": null
    }
  ]
},
v166 = [
  {
    "alias": "videoUploadToolsFeatureFlag",
    "args": [
      {
        "kind": "Literal",
        "name": "feature",
        "value": "videoUploadTools"
      }
    ],
    "kind": "ScalarField",
    "name": "featureFlag",
    "storageKey": "featureFlag(feature:\"videoUploadTools\")"
  }
],
v167 = {
  "alias": null,
  "args": null,
  "concreteType": "gdprDisplayInfo",
  "kind": "LinkedField",
  "name": "gdprDisplayInfo",
  "plural": false,
  "selections": [
    (v162/*: any*/)
  ],
  "storageKey": null
},
v168 = [
  (v8/*: any*/),
  (v5/*: any*/)
],
v169 = [
  (v40/*: any*/)
],
v170 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "variant",
  "storageKey": null
},
v171 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v172 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanceled",
  "storageKey": null
},
v173 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v174 = {
  "alias": null,
  "args": null,
  "concreteType": "UserPreferences",
  "kind": "LinkedField",
  "name": "preferences",
  "plural": false,
  "selections": [
    (v39/*: any*/)
  ],
  "storageKey": null
},
v175 = {
  "alias": "mcRedactionOpopAbTest",
  "args": [
    {
      "kind": "Literal",
      "name": "testName",
      "value": "MC_removeRedactionOPOP_Mar2026"
    }
  ],
  "concreteType": "AbTestConfigV2UserVariant",
  "kind": "LinkedField",
  "name": "abTestV2",
  "plural": false,
  "selections": [
    (v170/*: any*/)
  ],
  "storageKey": "abTestV2(testName:\"MC_removeRedactionOPOP_Mar2026\")"
},
v176 = [
  (v9/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "page",
    "value": 0
  }
],
v177 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v178 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v179 = {
  "condition": "isEstimateSimilarSoldVariant",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        (v165/*: any*/)
      ]
    }
  ]
},
v180 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVerifiedTrade",
  "storageKey": null
},
v181 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canShowSellerName",
  "storageKey": null
},
v182 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "preferences",
    "plural": false,
    "selections": [
      (v135/*: any*/)
    ],
    "storageKey": null
  }
],
v183 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeFirmRewards",
  "kind": "LinkedField",
  "name": "rewards",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParentProgram",
      "kind": "LinkedField",
      "name": "currentProgram",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LoyaltyProgram",
          "kind": "LinkedField",
          "name": "programInfo",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": "ENHANCED_BUYER_PROTECTION"
            }
          ],
          "concreteType": "LoyaltyProgram",
          "kind": "LinkedField",
          "name": "childPrograms",
          "plural": true,
          "selections": (v6/*: any*/),
          "storageKey": "childPrograms(filter:\"ENHANCED_BUYER_PROTECTION\")"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v184 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v185 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpRespMarketplaceLayoutPrimaryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpRespMarketplaceLayoutPrimary_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PdpRespMarketplaceLayoutPrimaryRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": "showAddToCartButton",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "multiItemCartAddToCartButton"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"multiItemCartAddToCartButton\")"
          },
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "itemRead",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "itemIsOnHold",
                    "args": (v10/*: any*/),
                    "kind": "ScalarField",
                    "name": "isOnHold",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAccessible",
                        "storageKey": null
                      },
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isInternal",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": (v21/*: any*/),
                            "concreteType": "BuyerOrderReviewType",
                            "kind": "LinkedField",
                            "name": "buyerOrderReview",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v23/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "image",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "pdpUrl",
                                "storageKey": null
                              },
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v24/*: any*/),
                    "concreteType": "ItemDisplayInfo",
                    "kind": "LinkedField",
                    "name": "displayInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CTADisplay",
                        "kind": "LinkedField",
                        "name": "ctas",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PriceInfoDisplay",
                        "kind": "LinkedField",
                        "name": "pricing",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showSale",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "showNet",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PriceInfoDisplay",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showUnavailable",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CTADisplay",
                            "kind": "LinkedField",
                            "name": "ctas",
                            "plural": false,
                            "selections": [
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v29/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "condition": "isPdpSiderailSellerReviewCombinedVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v30/*: any*/)
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSkuType",
                    "kind": "LinkedField",
                    "name": "skus",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      (v5/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      {
                        "condition": "isPdpSiderailSellerReviewCombinedVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v46/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  (v47/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemClassification",
                    "kind": "LinkedField",
                    "name": "classification",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "creationDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCategory",
                        "kind": "LinkedField",
                        "name": "categories",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "precedence",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v48/*: any*/),
                              (v49/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemCreator",
                    "kind": "LinkedField",
                    "name": "creators",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "attribution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Creator",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v48/*: any*/),
                          (v50/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDyoCustomizable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isPublishedPrivate",
                    "storageKey": null
                  },
                  (v54/*: any*/),
                  (v55/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                      (v56/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSold",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isListingNotListed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isListingUnlisted",
                    "storageKey": null
                  },
                  {
                    "alias": "categoryL2",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "level",
                        "value": 2
                      }
                    ],
                    "concreteType": "Category",
                    "kind": "LinkedField",
                    "name": "getCategoriesByLevel",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": "getCategoriesByLevel(level:2)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMultiSku",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultSkuId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contemporaryTrackingString",
                    "storageKey": null
                  },
                  (v49/*: any*/),
                  (v57/*: any*/),
                  (v58/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isListingListed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sourceLocale",
                    "storageKey": null
                  },
                  {
                    "condition": "afterDisplayOrBtSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v59/*: any*/),
                          (v60/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SkuQuantityOption",
                            "kind": "LinkedField",
                            "name": "quantitySelectOptions",
                            "plural": true,
                            "selections": [
                              (v61/*: any*/),
                              (v62/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "setSize",
                            "storageKey": null
                          },
                          (v46/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v63/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SaveSearchDataType",
                        "kind": "LinkedField",
                        "name": "saveSearchData",
                        "plural": false,
                        "selections": [
                          (v48/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "page",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v64/*: any*/),
                      (v65/*: any*/),
                      (v66/*: any*/),
                      (v67/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v68/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v70/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isDeleted",
                        "storageKey": null
                      },
                      (v71/*: any*/),
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemAttributes",
                            "kind": "LinkedField",
                            "name": "attributes",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AttributeValue",
                                "kind": "LinkedField",
                                "name": "framingStatus",
                                "plural": true,
                                "selections": (v72/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": "displayPriceDefault",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "DEFAULT"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v73/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"DEFAULT\")"
                              },
                              {
                                "alias": "displayPriceAU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "AU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v73/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"AU\")"
                              },
                              {
                                "alias": "displayPriceEU",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "EU"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v73/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"EU\")"
                              },
                              {
                                "alias": "displayPriceGB",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "priceBookName",
                                    "value": "GB"
                                  }
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": (v73/*: any*/),
                                "storageKey": "displayPrice(priceBookName:\"GB\")"
                              }
                            ],
                            "storageKey": null
                          },
                          (v74/*: any*/),
                          (v45/*: any*/),
                          (v81/*: any*/)
                        ]
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v82/*: any*/),
                          (v83/*: any*/)
                        ]
                      },
                      {
                        "condition": "isMultiSku",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSkuType",
                            "kind": "LinkedField",
                            "name": "skus",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v24/*: any*/),
                                "concreteType": "SkuDisplayInfo",
                                "kind": "LinkedField",
                                "name": "displayInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CTADisplay",
                                    "kind": "LinkedField",
                                    "name": "ctas",
                                    "plural": false,
                                    "selections": [
                                      (v26/*: any*/),
                                      (v27/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v25/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isPdpSiderailSellerReviewCombinedVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          {
                            "condition": "isMultiSku",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SkuRingSizeDisplay",
                                "kind": "LinkedField",
                                "name": "ringSizeDisplay",
                                "plural": false,
                                "selections": [
                                  (v84/*: any*/),
                                  (v85/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "storyTelling",
                        "args": (v86/*: any*/),
                        "concreteType": "StoryTellingModule",
                        "kind": "LinkedField",
                        "name": "storyTellingModule",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingTab",
                            "kind": "LinkedField",
                            "name": "tabs",
                            "plural": true,
                            "selections": [
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v89/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoryTellingModuleCreator",
                                "kind": "LinkedField",
                                "name": "contentCreatorAttribution",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "creatorName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LinkData",
                                    "kind": "LinkedField",
                                    "name": "creatorBrowseUrl",
                                    "plural": false,
                                    "selections": (v90/*: any*/),
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v91/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mainImage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "mainVideo",
                                "storageKey": null
                              },
                              (v92/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "smallImage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "storyTellingModule(shortTitles:true)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StorefrontProfile",
                            "kind": "LinkedField",
                            "name": "liveStorefrontProfile",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "aboutUsUnbranded",
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              {
                                "alias": "headshots",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "photoType",
                                    "value": "DEALER_STOREFRONT_HEADSHOT"
                                  }
                                ],
                                "concreteType": "Photo",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                  (v68/*: any*/),
                                  (v52/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MediaAlbum",
                                "kind": "LinkedField",
                                "name": "galleryAlbum",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MediaElement",
                                    "kind": "LinkedField",
                                    "name": "mediaList",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "element",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v52/*: any*/)
                                            ],
                                            "type": "Photo",
                                            "abstractKey": null
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "url",
                                                "storageKey": null
                                              }
                                            ],
                                            "type": "Video",
                                            "abstractKey": null
                                          },
                                          (v93/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "establishmentYear",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderFeedbackPdp",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v94/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "shippingAddress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "displayFullCityStateCountry",
                                "args": (v95/*: any*/),
                                "kind": "ScalarField",
                                "name": "displayCityStateCountry",
                                "storageKey": "displayCityStateCountry(fullCountryName:true)"
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v18/*: any*/),
                          {
                            "alias": "dealerDetailsHeaderFeedback",
                            "args": [
                              (v96/*: any*/),
                              (v97/*: any*/),
                              (v98/*: any*/)
                            ],
                            "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                            "kind": "LinkedField",
                            "name": "orderFeedbackPdp",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": (v99/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4)"
                          },
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "agreementStart",
                            "storageKey": null
                          },
                          (v100/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MCAnalytics",
                            "kind": "LinkedField",
                            "name": "analytics",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MCAnalyticsMetrics",
                                "kind": "LinkedField",
                                "name": "metrics",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MCMetricResponseTime",
                                    "kind": "LinkedField",
                                    "name": "responseTime",
                                    "plural": false,
                                    "selections": (v72/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeAssociation",
                            "kind": "LinkedField",
                            "name": "tradeAssociations",
                            "plural": true,
                            "selections": [
                              (v11/*: any*/),
                              (v50/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "afterDisplay",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "dealerDetailsOrderFeedbackPdp",
                                "args": [
                                  (v96/*: any*/),
                                  (v97/*: any*/),
                                  (v98/*: any*/),
                                  {
                                    "kind": "Literal",
                                    "name": "sortBy",
                                    "value": "sellerExperienceDesc"
                                  }
                                ],
                                "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                                "kind": "LinkedField",
                                "name": "orderFeedbackPdp",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "SellerOrderFeedbackPdpQueryEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderFeedbackPdp",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "completedDate",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Transaction",
                                            "kind": "LinkedField",
                                            "name": "transaction",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "buyer",
                                                "plural": false,
                                                "selections": [
                                                  (v102/*: any*/),
                                                  (v5/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Shipment",
                                                "kind": "LinkedField",
                                                "name": "shipment",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Address",
                                                    "kind": "LinkedField",
                                                    "name": "shippingAddress",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "displayState",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "displayCountry",
                                                        "storageKey": null
                                                      },
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "country",
                                                        "storageKey": null
                                                      },
                                                      (v5/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v5/*: any*/)
                                                ],
                                                "storageKey": null
                                              },
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "overallExperience",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v22/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "publicNote",
                                            "plural": false,
                                            "selections": [
                                              (v8/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "freetext",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "orderFeedbackPdp(feedbackSellerPublicNoteHasText:true,first:3,minimumReviewRating:4,sortBy:\"sellerExperienceDesc\")"
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      (v103/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v105/*: any*/),
                          (v106/*: any*/),
                          (v107/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isListingMigrated",
                        "storageKey": null
                      },
                      (v108/*: any*/),
                      (v116/*: any*/),
                      (v117/*: any*/),
                      (v67/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasShipmentQuotes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v21/*: any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accept",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReturnPolicyCopy",
                            "kind": "LinkedField",
                            "name": "buyerCopy",
                            "plural": false,
                            "selections": [
                              (v119/*: any*/),
                              (v120/*: any*/),
                              (v121/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "itemAddress",
                            "args": (v95/*: any*/),
                            "kind": "ScalarField",
                            "name": "displayCityStateCountry",
                            "storageKey": "displayCityStateCountry(fullCountryName:true)"
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v63/*: any*/),
                      (v64/*: any*/),
                      (v123/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v124/*: any*/),
                          (v126/*: any*/),
                          (v127/*: any*/)
                        ]
                      },
                      (v129/*: any*/),
                      (v130/*: any*/),
                      {
                        "condition": "isPdpSimilarSoldItemsModuleVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "condition": "afterDisplay",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": "categoryL3",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "level",
                                    "value": 3
                                  }
                                ],
                                "concreteType": "Category",
                                "kind": "LinkedField",
                                "name": "getCategoriesByLevel",
                                "plural": true,
                                "selections": (v131/*: any*/),
                                "storageKey": "getCategoriesByLevel(level:3)"
                              },
                              (v132/*: any*/),
                              (v133/*: any*/),
                              (v134/*: any*/),
                              (v137/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "fetchPdp",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Phone",
                                "kind": "LinkedField",
                                "name": "trackedPhone",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "phoneNumber",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v138/*: any*/),
                              (v8/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "dealerDetailsDisplayInfo",
                            "args": null,
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": (v30/*: any*/),
                            "storageKey": null
                          },
                          {
                            "condition": "fetchUser",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v139/*: any*/),
                              (v140/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v123/*: any*/),
                      (v126/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v107/*: any*/),
                          (v105/*: any*/),
                          (v106/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v21/*: any*/),
                        "concreteType": "ReturnPolicy",
                        "kind": "LinkedField",
                        "name": "returnPolicy",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReturnPolicyCopy",
                            "kind": "LinkedField",
                            "name": "buyerCopy",
                            "plural": false,
                            "selections": [
                              (v121/*: any*/),
                              (v119/*: any*/),
                              (v120/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v141/*: any*/),
                      (v108/*: any*/),
                      (v103/*: any*/),
                      (v116/*: any*/),
                      (v117/*: any*/),
                      (v67/*: any*/),
                      (v142/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isJewelry",
                        "storageKey": null
                      },
                      (v64/*: any*/),
                      (v143/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v127/*: any*/),
                          (v139/*: any*/),
                          (v140/*: any*/)
                        ]
                      },
                      (v130/*: any*/)
                    ]
                  },
                  {
                    "condition": "isPDPLargerItemsVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoVimeo",
                        "kind": "LinkedField",
                        "name": "videoVimeo",
                        "plural": false,
                        "selections": [
                          (v68/*: any*/),
                          (v144/*: any*/),
                          (v8/*: any*/),
                          (v147/*: any*/),
                          {
                            "alias": null,
                            "args": (v31/*: any*/),
                            "concreteType": "VideoVimeoFile",
                            "kind": "LinkedField",
                            "name": "fileByVideoSize",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "link",
                                "storageKey": null
                              }
                            ],
                            "storageKey": "fileByVideoSize(size:\"small\")"
                          }
                        ],
                        "storageKey": null
                      },
                      (v148/*: any*/),
                      (v149/*: any*/),
                      (v151/*: any*/),
                      (v153/*: any*/),
                      (v154/*: any*/),
                      (v67/*: any*/)
                    ]
                  },
                  {
                    "condition": "isPDPLargerItemsVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VideoVimeo",
                        "kind": "LinkedField",
                        "name": "videoVimeo",
                        "plural": false,
                        "selections": [
                          (v68/*: any*/),
                          (v144/*: any*/),
                          (v8/*: any*/),
                          (v147/*: any*/),
                          {
                            "alias": "previewThumbnail",
                            "args": [
                              (v145/*: any*/),
                              (v146/*: any*/),
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w960h540"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "thumbnail",
                            "storageKey": "thumbnail(includePlayButton:false,pad:false,size:\"w960h540\")"
                          }
                        ],
                        "storageKey": null
                      },
                      (v148/*: any*/),
                      (v149/*: any*/),
                      (v151/*: any*/),
                      (v153/*: any*/),
                      (v154/*: any*/),
                      (v67/*: any*/)
                    ]
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v71/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VariableAttribute",
                        "kind": "LinkedField",
                        "name": "variableAttributes",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VariableAttributeSortType",
                            "kind": "LinkedField",
                            "name": "variableAttributeData",
                            "plural": false,
                            "selections": [
                              (v50/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Attribute",
                                "kind": "LinkedField",
                                "name": "primaryAttribute",
                                "plural": false,
                                "selections": (v131/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SwatchSort",
                                "kind": "LinkedField",
                                "name": "swatchSort",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sortOrder",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Swatch",
                                    "kind": "LinkedField",
                                    "name": "swatch",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v50/*: any*/),
                                      (v149/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "imageUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "ringSize",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SwatchAttributeByNameProperties",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                              (v85/*: any*/),
                                              (v84/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "material",
                                        "plural": false,
                                        "selections": [
                                          (v48/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SwatchAttributeByName",
                                        "kind": "LinkedField",
                                        "name": "color",
                                        "plural": false,
                                        "selections": [
                                          (v48/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "parentName",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "buyerSideSkus",
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": (v128/*: any*/),
                            "kind": "ScalarField",
                            "name": "firstPhotoWebPath",
                            "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPricing",
                            "kind": "LinkedField",
                            "name": "pricing",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hidePrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "retailPrice",
                                "plural": false,
                                "selections": (v155/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "netPrice",
                                "plural": false,
                                "selections": (v155/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "salePrice",
                                "plural": false,
                                "selections": (v155/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v59/*: any*/),
                          (v60/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "pageType",
                                "value": "PDP"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "leadTime",
                            "storageKey": "leadTime(pageType:\"PDP\")"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "variableAttributeSelectionsType",
                            "kind": "LinkedField",
                            "name": "variableAttributeSelections",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "VariableAttribute",
                                "kind": "LinkedField",
                                "name": "variableAttribute",
                                "plural": false,
                                "selections": (v94/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Swatch",
                                "kind": "LinkedField",
                                "name": "swatch",
                                "plural": false,
                                "selections": (v94/*: any*/),
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isPdpSiderailSellerReviewCombinedVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v117/*: any*/),
                      (v108/*: any*/),
                      (v67/*: any*/),
                      (v142/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCondition",
                        "kind": "LinkedField",
                        "name": "condition",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "state",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PdpDetail",
                        "kind": "LinkedField",
                        "name": "pdpDetailsDisplay",
                        "plural": true,
                        "selections": [
                          (v109/*: any*/),
                          (v110/*: any*/),
                          (v111/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "detailValues",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              (v33/*: any*/),
                              (v49/*: any*/),
                              (v109/*: any*/),
                              (v50/*: any*/),
                              (v113/*: any*/),
                              (v112/*: any*/),
                              (v115/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v86/*: any*/),
                        "concreteType": "StoryTellingModule",
                        "kind": "LinkedField",
                        "name": "storyTellingModule",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StoryTellingTab",
                            "kind": "LinkedField",
                            "name": "tabs",
                            "plural": true,
                            "selections": [
                              (v87/*: any*/),
                              (v88/*: any*/),
                              (v89/*: any*/),
                              (v91/*: any*/),
                              (v92/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StoryTellingModuleCreator",
                                "kind": "LinkedField",
                                "name": "contentCreatorAttribution",
                                "plural": false,
                                "selections": (v99/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "storyTellingModule(shortTitles:true)"
                      },
                      (v103/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          (v105/*: any*/),
                          (v106/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v64/*: any*/),
                      (v143/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isOnHold",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPriceUponRequest",
                        "storageKey": null
                      },
                      (v74/*: any*/),
                      (v45/*: any*/),
                      (v65/*: any*/),
                      (v66/*: any*/),
                      (v70/*: any*/),
                      (v130/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v124/*: any*/),
                          (v82/*: any*/),
                          (v83/*: any*/)
                        ]
                      },
                      (v129/*: any*/)
                    ]
                  },
                  {
                    "condition": "isPdpSimilarSoldItemsModuleVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "condition": "afterDisplayOrBtSsr",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v81/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "Item",
                "abstractKey": null
              },
              (v93/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "similarLandingItems",
            "args": [
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "similarItemsCount"
              },
              (v35/*: any*/),
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "useML",
                "value": true
              }
            ],
            "concreteType": "moreLikeThisItemConnection",
            "kind": "LinkedField",
            "name": "moreLikeThisItem",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "moreLikeThisItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v58/*: any*/),
                      (v57/*: any*/),
                      (v49/*: any*/),
                      (v23/*: any*/),
                      (v141/*: any*/),
                      (v54/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemCreator",
                        "kind": "LinkedField",
                        "name": "creators",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Creator",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": (v131/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 1
                          }
                        ],
                        "concreteType": "ItemPhoto",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": true,
                        "selections": [
                          (v152/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhotoVersion",
                            "kind": "LinkedField",
                            "name": "versions",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "webPath",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": "photos(limit:1)"
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "condition": "isPdpSiderailSellerReviewCombinedVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "isPdpSimilarSoldItemsModuleVariant",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v159/*: any*/)
                        ]
                      },
                      {
                        "alias": null,
                        "args": (v156/*: any*/),
                        "concreteType": "SimilarSoldItemsConnectionConnection",
                        "kind": "LinkedField",
                        "name": "similarSoldItemsConnection",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SimilarSoldItemsConnectionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SimilarSoldItemsNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v160/*: any*/),
                                  (v161/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v49/*: any*/),
                                      (v57/*: any*/),
                                      (v141/*: any*/),
                                      (v5/*: any*/),
                                      (v11/*: any*/),
                                      (v23/*: any*/),
                                      (v55/*: any*/),
                                      (v132/*: any*/),
                                      (v133/*: any*/),
                                      (v134/*: any*/),
                                      (v137/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PdpDetail",
                                        "kind": "LinkedField",
                                        "name": "pdpDetailsDisplay",
                                        "plural": true,
                                        "selections": [
                                          (v109/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "detailValues",
                                            "plural": true,
                                            "selections": [
                                              (v8/*: any*/),
                                              (v50/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "soldDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v159/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "gdprDisplayInfo",
                    "kind": "LinkedField",
                    "name": "gdprDisplayInfo",
                    "plural": false,
                    "selections": [
                      (v162/*: any*/),
                      (v163/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "detectFeedbackLanguage",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "detectFeedbackLanguage"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"detectFeedbackLanguage\")"
                  }
                ]
              },
              (v164/*: any*/),
              (v165/*: any*/)
            ]
          },
          {
            "condition": "isPDPLargerItemsVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": (v166/*: any*/)
          },
          {
            "condition": "isPDPLargerItemsVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v166/*: any*/)
          },
          {
            "condition": "fetchPdp",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "isPdpStfEnabled",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "feature",
                    "value": "enablePdpStf"
                  }
                ],
                "kind": "ScalarField",
                "name": "featureFlag",
                "storageKey": "featureFlag(feature:\"enablePdpStf\")"
              },
              {
                "condition": "afterDisplay",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "condition": "fetchPdp",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v167/*: any*/),
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "gdprDisplayInfo",
                            "kind": "LinkedField",
                            "name": "gdprDisplayInfo",
                            "plural": false,
                            "selections": [
                              (v163/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "afterDisplay",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v7/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v82/*: any*/),
                      {
                        "alias": null,
                        "args": (v21/*: any*/),
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "activePromotion",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Seller",
                        "kind": "LinkedField",
                        "name": "seller",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SellerTiers",
                            "kind": "LinkedField",
                            "name": "sellerTiers",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dealerSince",
                            "storageKey": null
                          },
                          (v100/*: any*/),
                          (v14/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "viewInRoomPhotos",
                        "kind": "LinkedField",
                        "name": "viewInRoomPhotos",
                        "plural": true,
                        "selections": (v99/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSkuType",
                        "kind": "LinkedField",
                        "name": "skus",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemPhoto",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": (v168/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v75/*: any*/),
                        "concreteType": "PricingGuidance",
                        "kind": "LinkedField",
                        "name": "pricingGuidance",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "price",
                            "plural": false,
                            "selections": (v169/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "minAmount",
                            "plural": false,
                            "selections": (v169/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "maxAmount",
                            "plural": false,
                            "selections": (v169/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "condition": "afterDisplay",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AbTestConfigV2UserVariant",
                            "kind": "LinkedField",
                            "name": "seoAbTestV2List",
                            "plural": true,
                            "selections": [
                              (v170/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AbTestConfigV2",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "testName",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v1/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "pageSize",
                    "value": 10
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "personalizationId"
                  }
                ],
                "concreteType": "PersonalizedItems",
                "kind": "LinkedField",
                "name": "personalizedItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "associationType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPersonalizedItem",
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "BuyerUrgencyInfo",
                "kind": "LinkedField",
                "name": "buyerUrgencyInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalConversations",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemUrgencyInfoType",
                    "kind": "LinkedField",
                    "name": "itemUrgency",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urgencyInfoType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "count",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasUrgencyInfo",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "userCountryCode"
                  },
                  (v1/*: any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "kind": "LinkedField",
                "name": "transactionWarnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRestrictedMaterials",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v167/*: any*/),
              (v159/*: any*/),
              (v164/*: any*/),
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v21/*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v168/*: any*/),
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "isInteractivePdpChat",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v7/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "itemRead",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "seller",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerTiers",
                                "kind": "LinkedField",
                                "name": "sellerTiers",
                                "plural": false,
                                "selections": [
                                  (v17/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v138/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Address",
                                "kind": "LinkedField",
                                "name": "shippingAddress",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayCityStateCountry",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PresenceResults",
                                "kind": "LinkedField",
                                "name": "presence",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "recentOnlineDate",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "kind": "LinkedField",
                                "name": "sellerPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "showOnlineStatus",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v103/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isUnavailable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuotes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isComplimentary",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isCalculated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "totalAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmounts",
                                    "kind": "LinkedField",
                                    "name": "convertedAmounts",
                                    "plural": false,
                                    "selections": [
                                      (v69/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShipmentServiceMethod",
                                "kind": "LinkedField",
                                "name": "serviceMethod",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Region",
                                    "kind": "LinkedField",
                                    "name": "region",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "regionName",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "buyerChatDisplayInfo",
                            "args": null,
                            "concreteType": "ItemDisplayInfo",
                            "kind": "LinkedField",
                            "name": "displayInfo",
                            "plural": false,
                            "selections": (v30/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Item",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "presenceFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "presence"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"presence\")"
                  },
                  {
                    "alias": "readReceiptsFeatureFlag",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "feature",
                        "value": "readReceipts"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "featureFlag",
                    "storageKey": "featureFlag(feature:\"readReceipts\")"
                  },
                  {
                    "condition": "fetchUser",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          (v9/*: any*/),
                          (v1/*: any*/)
                        ],
                        "concreteType": "Conversation",
                        "kind": "LinkedField",
                        "name": "buyerItemConversation",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasMessageFromSeller",
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasUnreadMessageForMember",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationMember",
                            "kind": "LinkedField",
                            "name": "originalBuyer",
                            "plural": false,
                            "selections": (v94/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Transaction",
                            "kind": "LinkedField",
                            "name": "transaction",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemSkuType",
                                "kind": "LinkedField",
                                "name": "sku",
                                "plural": false,
                                "selections": (v94/*: any*/),
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderFeedback",
                                "kind": "LinkedField",
                                "name": "orderFeedback",
                                "plural": false,
                                "selections": [
                                  (v68/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "token",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Member",
                            "kind": "LinkedField",
                            "name": "sellerMember",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastConversationReadDate",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Message",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "userType",
                                    "value": "BUYER"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "translatedTextBody",
                                "storageKey": "translatedTextBody(userType:\"BUYER\")"
                              },
                              (v5/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "textBody",
                                "storageKey": null
                              },
                              (v171/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "fromUserId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shipmentTrackingNumber",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAction",
                                "kind": "LinkedField",
                                "name": "action",
                                "plural": false,
                                "selections": (v131/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Anchor",
                                "kind": "LinkedField",
                                "name": "anchors",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "sourceType",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MessageAttachment",
                                "kind": "LinkedField",
                                "name": "attachments",
                                "plural": true,
                                "selections": (v168/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedNetPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadePrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeNetPriceOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMadeOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionAutomatedPrivateOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionSpecialShippingRequests",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionRequestedHold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldPlaced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldReleased",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionShippingQuoteRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCallInitiated",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomizationOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionCustomization",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBundledOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionPrivateOfferHoldSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionHoldShippingQuoteSent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionInternalAdminJoined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionMarkedShipped",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnRequested",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclinedApproved",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnCompleted",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionReturnDeclined",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionDealerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "actionBuyerCounterOffer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Offer",
                                "kind": "LinkedField",
                                "name": "offer",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isApoFromCart",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "expirationDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isExpired",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isSubmitted",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isRevisedByDealer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCountered",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FinancialAmount",
                                    "kind": "LinkedField",
                                    "name": "amountPerItem",
                                    "plural": false,
                                    "selections": (v77/*: any*/),
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Transaction",
                                "kind": "LinkedField",
                                "name": "transaction",
                                "plural": false,
                                "selections": [
                                  (v172/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Offer",
                                    "kind": "LinkedField",
                                    "name": "mostRecentOffer",
                                    "plural": false,
                                    "selections": (v94/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TransactionSummaryObject",
                                    "kind": "LinkedField",
                                    "name": "summary",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "offerDiscountPercentage",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConversationMember",
                                "kind": "LinkedField",
                                "name": "from",
                                "plural": false,
                                "selections": (v94/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v21/*: any*/),
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Profile",
                            "kind": "LinkedField",
                            "name": "profile",
                            "plural": false,
                            "selections": [
                              (v101/*: any*/),
                              (v173/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v174/*: any*/),
                          (v175/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Summary",
                            "kind": "LinkedField",
                            "name": "conversationSummary",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unread",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v176/*: any*/),
                        "concreteType": "ConversationsSolrConnection",
                        "kind": "LinkedField",
                        "name": "conversationsSolr",
                        "plural": false,
                        "selections": [
                          (v157/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ConversationsSolrEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Conversation",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessage",
                                    "storageKey": null
                                  },
                                  (v171/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "inboxImage",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "numberOfMessages",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "item",
                                    "plural": false,
                                    "selections": [
                                      (v23/*: any*/),
                                      (v11/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ItemSkuType",
                                    "kind": "LinkedField",
                                    "name": "sku",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "skuPhotoWebPath",
                                        "args": (v31/*: any*/),
                                        "kind": "ScalarField",
                                        "name": "firstPhotoWebPath",
                                        "storageKey": "firstPhotoWebPath(size:\"small\")"
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "latestMessageReceivedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "hasReplied",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isLatestMessageSender",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ConversationMember",
                                    "kind": "LinkedField",
                                    "name": "originalBuyer",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hasUnreadTag",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v177/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v178/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "conversations",
                        "args": (v176/*: any*/),
                        "filters": [
                          "page",
                          "buyerId"
                        ],
                        "handle": "connection",
                        "key": "BuyerChatVariant_conversations",
                        "kind": "LinkedHandle",
                        "name": "conversationsSolr"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isPdpSiderailSellerReviewCombinedVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v179/*: any*/)
            ]
          },
          (v179/*: any*/),
          {
            "condition": "isPdpSimilarSoldItemsModuleVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "condition": "afterDisplayOrBtSsr",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v156/*: any*/),
                    "concreteType": "SimilarSoldItemsConnectionConnection",
                    "kind": "LinkedField",
                    "name": "similarSoldItemsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SimilarSoldItemsConnectionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SimilarSoldItemsNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v160/*: any*/),
                              (v161/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v49/*: any*/),
                                  (v57/*: any*/),
                                  (v141/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v21/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasMerchandizingPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "BUYER_FE_MERCH_TOOL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v173/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v11/*: any*/),
                  (v5/*: any*/),
                  {
                    "condition": "isPdpSiderailSellerReviewCombinedVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v102/*: any*/),
                      (v180/*: any*/),
                      (v174/*: any*/),
                      (v175/*: any*/),
                      (v181/*: any*/),
                      {
                        "condition": "isPdpSimilarSoldItemsModuleVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "condition": "afterDisplay",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": (v182/*: any*/)
                          }
                        ]
                      },
                      {
                        "condition": "isTrade",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmType",
                            "kind": "LinkedField",
                            "name": "tradeFirm",
                            "plural": false,
                            "selections": [
                              (v183/*: any*/),
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v184/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v21/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v184/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v21/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "isPDPLargerItemsVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": (v182/*: any*/)
                  },
                  {
                    "condition": "isPDPLargerItemsVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v182/*: any*/)
                  },
                  {
                    "condition": "isMultiSku",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v180/*: any*/)
                    ]
                  },
                  {
                    "condition": "afterDisplay",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v180/*: any*/),
                      (v181/*: any*/),
                      {
                        "condition": "isTrade",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmType",
                            "kind": "LinkedField",
                            "name": "tradeFirm",
                            "plural": false,
                            "selections": [
                              (v183/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "afterDisplayOrBtSsr",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      (v180/*: any*/),
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v185/*: any*/),
                            "concreteType": "favoritesConnection",
                            "kind": "LinkedField",
                            "name": "favorites",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "favoritesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Favorite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v50/*: any*/),
                                      (v5/*: any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v177/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v178/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v185/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "SharedSaveSearchContext_favorites",
                            "kind": "LinkedHandle",
                            "name": "favorites"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isMultiSku",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userIds"
                  },
                  {
                    "kind": "Variable",
                    "name": "itemId",
                    "variableName": "itemIds"
                  }
                ],
                "concreteType": "TransactionConnection",
                "kind": "LinkedField",
                "name": "transactions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TransactionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Transaction",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v33/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPrivateOffer",
                            "storageKey": null
                          },
                          (v172/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/557.0.0-2026-04-29T16:01:43.567Z/PdpRespMarketplaceLayoutPrimaryRefetchQuery",
    "metadata": {},
    "name": "PdpRespMarketplaceLayoutPrimaryRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "acee2177c0e71ad0b9f2663e758bf74e";

export default node;
